<template>
  <div class="qmyx-container container">
    <div class="total-data">
      <div class="total-cash">
        <div class="total-title">总计（元）</div>
        <div class="total-count">{{ totalCash }}</div>
      </div>
      <div class="other-cash">
        <div class="item">
          <div class="title">待结佣（元）</div>
          <div class="count">{{ unpaidCash }}</div>
        </div>
        <div class="sep-line" />
        <div class="item">
          <div class="title">已结佣（元）</div>
          <div class="count">{{ paidCash }}</div>
        </div>
      </div>
    </div>
    <div class="notice-tag">
      <img
        src="https://assets.rurushishi.com/yq-rs-make/huafa/img/notice.png"
        alt=""
        class="notice-icon"
      />
      <div class="notice-context">
        本页面所示的佣金金额为含税金额，实际的佣金金额需以到帐金额为准
      </div>
    </div>
    <div class="cash-records-list">
      <div class="records-list-title">佣金记录</div>

      <div class="no-records" v-if="records.length === 0">
        <img
          src="https://assets.rurushishi.com/yq-rs-make/huafa/img/box.png"
          alt=""
          class="no-records-img"
        />
        <div class="no-records-tag">您还未产生佣金记录</div>
      </div>
      <div
        v-else
        class="records-item"
        v-for="(item, index) in records"
        :key="index"
      >
        <div class="records-item-head">
          <div class="records-item-info">
            <div class="records-type">{{ item.cusName }}</div>
            <div class="records-phone">{{ item.cusTel }}</div>
          </div>
          <div class="records-item-status" :class="item.cashBackStatus">
            {{ item.cashBackStatusTag }}
          </div>
        </div>
        <div class="records-item-content">
          <div class="item">
            成交楼盘：<span>{{ item.housesD }}</span>
          </div>
          <div class="item">
            成交时间：<span>{{ item.formatDate }}</span>
          </div>
          <div class="item">
            佣金金额：<span>{{ item.apAmount }}元</span>
          </div>
          <div class="item">
            累计已发放：<span>{{ item.actAmount }}元</span>
          </div>
          <div class="item">
            本次待发放：<span>{{ item.actPayAmount }}元</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from "vuex";
import { getAgent } from "../api";
import { getMoneyAndAwardData } from "./api";
export default {
  data() {
    return {
      totalCash: 0,
      paidCash: 0,
      unpaidCash: 0,
      records: []
    };
  },
  computed: {
    ...mapState("qmyx", ["agentId"])
  },
  methods: {
    ...mapMutations("qmyx", ["saveAgentId"])
  },
  async activated() {
    const _this = this;
    if (!_this.agentId) {
      let { agentLogin } = await getAgent();
      _this.saveAgentId(agentLogin.id);
    }
    let resp = await getMoneyAndAwardData(_this.agentId);
    _this.totalCash = isNaN(Number(resp.allMoney)) ? 0 : Number(resp.allMoney);
    _this.paidCash = isNaN(Number(resp.payMoney)) ? 0 : Number(resp.payMoney);
    _this.unpaidCash = _this.totalCash - _this.paidCash;
    _this.records = resp.record || [];
    _this.records.forEach(item => {
      item.apAmount = isNaN(Number(item.apAmount)) ? 0 : Number(item.apAmount);
      item.actAmount = isNaN(Number(item.actAmount))
        ? 0
        : Number(item.actAmount);
      if (item.apAmount - item.actAmount === 0) {
        item.cashBackStatus = "paid";
        item.cashBackStatusTag = "已结算";
      } else if (item.actAmount === 0) {
        item.cashBackStatus = "unpaid";
        item.cashBackStatusTag = "未结算";
      } else if (item.apAmount - item.actAmount > 0) {
        item.cashBackStatus = "paying";
        item.cashBackStatusTag = "未结清";
      }
    });
  }
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  min-height: 100vh;
  background-color: #f4f4f4;
  display: flex;
  flex-direction: column;
  .line {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    width: 200%;
    height: 0.04rem;
    background-color: #f4f4f4;
    transform: scale(0.5, 0.5);
    transform-origin: 0 0;
  }

  & .total-data {
    width: 100%;
    background-color: #fff;
    & .total-cash {
      width: 100%;
      padding: 0.32rem 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      position: relative;
      & .total-title {
        font-size: 0.28rem;
        color: #999999;
      }
      & .total-count {
        font-size: 0.36rem;
        color: #f07b24;
        margin-top: 0.16rem;
      }
      &::after {
        @extend .line;
      }
    }
    & .other-cash {
      width: 100%;
      padding: 0.32rem 0;
      display: flex;
      align-items: stretch;
      position: relative;
      .sep-line {
        position: absolute;
        left: 50%;
        top: 0.32rem;
        bottom: 0.32rem;
        width: 0.04rem;
        background: #f4f4f4;
        transform: translateX(-50%) scale(0.5, 1);
        transform-origin: 50%;
      }
      .item {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
        & .title {
          font-size: 0.28rem;
          color: #999;
        }
        & .count {
          font-size: 0.36rem;
          color: #f07b24;
          margin-top: 0.16rem;
        }
      }
    }
  }
  & .notice-tag {
    padding: 0.24rem 0.3rem;
    display: flex;
    & .notice-icon {
      width: 0.24rem;
      height: 0.24rem;
      margin-right: 0.06rem;
    }
    & .notice-context {
      flex: 1;
      margin-top: -0.04rem;
      font-size: 0.24rem;
      line-height: 0.36rem;
      color: #999;
    }
  }
  & .cash-records-list {
    width: 100%;
    flex: 1;
    display: flex;
    flex-direction: column;
    & .records-list-title {
      width: 100%;
      font-weight: bold;
      box-sizing: border-box;
      padding: 0.32rem 0 0 0.3rem;
      font-size: 0.32rem;
      color: #333;
      background-color: #fff;
    }
    & .records-item {
      width: 100%;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      padding: 0.32rem 0 0.32rem 0.32rem;
      background-color: #fff;
      margin-bottom: 0.1rem;
      &:last-child {
        margin-bottom: 0rem;
      }
      & .records-item-head {
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 0.32rem;
        & .records-item-info {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          & .records-type {
            font-size: 0.28rem;
            color: #333;
            font-weight: bold;
          }
          & .records-phone {
            font-size: 0.28rem;
            color: #333;
            margin-top: 0.16rem;
          }
        }
        & .records-item-status {
          border-radius: 0.12rem 0px 0px 0.4rem;
          text-align: center;
          box-sizing: border-box;
          padding: 0.1rem 0.34rem;
          font-size: 0.28rem;
          display: flex;
          align-items: center;
          justify-content: center;
          &.paid {
            color: #0ab47b;
            background-color: #daffe8;
          }
          &.paying {
            color: #f07b24;
            background-color: #ffeee2;
          }
          &.unpaid {
            color: #ec4747;
            background-color: #ffecec;
          }
        }
      }
      & .records-item-content {
        flex: 1;
        & .item {
          font-size: 0.28rem;
          color: #333;
          & > span {
            color: #999;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          &:not(:first-child) {
            margin-top: 0.08rem;
          }
        }
      }
    }
    & .no-records {
      width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 0.86rem 0;
      background-color: #fff;
      & .no-records-img {
        width: 4.6rem;
      }
      & .no-records-tag {
        font-size: 0.28rem;
        color: #999;
        margin-top: 0;
      }
    }
  }
}
</style>
